import * as React from "react";
import Vehicles from "./Vehicles";
import IncHogar from "./IncHogar";

var RenderGeneral = function RenderGeneral(itemAsegurado) {
  return /*#__PURE__*/React.createElement("table", {
    className: "table"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Materia"), /*#__PURE__*/React.createElement("td", null, (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.materia_asegurada) || "-")));
};

var MateriaAseguradaDetails = function MateriaAseguradaDetails(props) {
  var itemAsegurado = props.itemAsegurado,
      ramo = props.ramo,
      currency = props.currency;

  switch (ramo) {
    case "INC. HOGAR":
      return /*#__PURE__*/React.createElement(IncHogar, {
        itemAsegurado: itemAsegurado,
        currency: currency
      });

    case "VEH. LIVIANOS":
      return /*#__PURE__*/React.createElement(Vehicles, {
        itemAsegurado: itemAsegurado,
        ramo: ramo,
        currency: currency
      });

    case "VEH. PESADOS":
      return /*#__PURE__*/React.createElement(Vehicles, {
        itemAsegurado: itemAsegurado,
        ramo: ramo,
        currency: currency
      });

    default:
      return RenderGeneral(itemAsegurado);
  }
};

export default MateriaAseguradaDetails;